import { Dispatch } from "@reduxjs/toolkit";
import type { AlertProps } from "@mui/material";
import { actions } from "rdx";

/**
 * Dispatches a global alert message with the given severity.
 *
 * @param {Dispatch} dispatch - Redux dispatch function
 * @param {string} message - The message to display
 * @param {AlertProps["severity"]} severity - The alert severity ("success" | "info" | "warning" | "error")
 * @returns {void} - This function does not return a value.
 */

export function showAlertHelper(
  dispatch: Dispatch,
  message: string,
  severity: AlertProps["severity"] = "success",
): void {
  dispatch(actions.setAlertMessageVisible({ message, severity }));
}
